import { isObservableMap, isObservableSet, toJS } from 'mobx'

// Recursively converts observable structures to plain JS, descending into POJOs,
// arrays, sets and maps (which toJS does not traverse on its own).
export function deepToJS<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => deepToJS(toJS(item))) as T
  }

  // Sets and Maps keep their entries in internal slots, so the generic object branch
  // below (which rebuilds from own enumerable keys) would return an empty object.
  if (value instanceof Set || isObservableSet(value)) {
    return new Set(Array.from(value, (item) => deepToJS(toJS(item)))) as T
  }

  // Keys are passed through untouched, like mobx's own toJS does, so entries keyed by
  // object reference stay reachable.
  if (value instanceof Map || isObservableMap(value)) {
    return new Map(
      Array.from(value, ([key, item]) => [key, deepToJS(toJS(item))] as const)
    ) as T
  }

  if (typeof value === 'object' && value !== null) {
    return Object.fromEntries(
      Object.entries(value).map(([key, value]) => [key, deepToJS(toJS(value))])
    ) as T
  }
  return value
}
